import React from 'react';
import block from 'bem-cn-lite';

import './style.styl';

const b = block('checkbox-new');

const Checkbox = ({ set, onClick, readOnly = false, withoutRightMargin = false, style = {} }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <span
    className={b({ set, 'margin-right-0': withoutRightMargin, read_only: readOnly })}
    onClick={e => !readOnly && onClick(e)}
    style={{ ...style }}
  >
    <img className={b('img')} src="/img/ok-1.svg" alt="ok" />
  </span>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./components/Checkbox/index.jsx